import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./lib/auth";
import Login from "./screens/Login";
import OnboardingFlow from "./screens/Onboarding/OnboardingFlow";
import Dashboard from "./screens/Dashboard";
import Log from "./screens/Log";
import Trends from "./screens/Trends";
import Settings from "./screens/Settings";
import BottomNav from "./components/BottomNav";

function FullScreenLoading() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-canvas">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-forest-300 border-t-forest-700" />
    </div>
  );
}

function AppShell() {
  return (
    <div className="flex min-h-dvh flex-col bg-canvas pb-[calc(4.5rem+env(safe-area-inset-bottom))]">
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/log" element={<Log />} />
          <Route path="/trends" element={<Trends />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <BottomNav />
    </div>
  );
}

export default function App() {
  const { user, hasProfile, loading } = useAuth();

  if (loading) return <FullScreenLoading />;

  if (!user) {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  if (!hasProfile) {
    return (
      <Routes>
        <Route path="*" element={<OnboardingFlow />} />
      </Routes>
    );
  }

  return <AppShell />;
}
